import React from "react";
import Nav from "../components/nav/nav";
import AdminDashboard from "../components/dashboard/admin-dashboard";

const AdminPage = () => {
  return (
    <div>
     <Nav/>
     <AdminDashboard/>
    </div>
  );
}

export default AdminPage;